<template>
  <v-container
    fluid
    id="workOrderPackage"
    class="pa-0 pa-sm-3"
    v-if="workOrderPackage"
  >
    <!-- HEADER -->
    <v-row wrap>
      <v-col cols="12" class="headline">
        <v-btn
          color="primary"
          class="mr-2 pa-0"
          small
          outlined
          text
          to="/work-orders/manage/orders"
          style="margin-top:-3px"
          ><v-icon>chevron_left</v-icon></v-btn
        >
        {{ workOrderPackage.workOrders[0].jobSite.street }}
        ({{ workOrderPackage.workOrders[0].jobSite.jobId }})
      </v-col>
      <v-col cols="12" class="py-0" v-if="workOrderPackage.emailSent">
        <span class="caption green--text font-weight-bold"
          ><v-icon small color="green">check</v-icon> Sent to billing</span
        >
      </v-col>
      <v-col
        cols="12"
        class="py-0"
        v-if="!workOrderPackage.approvers.every((a) => a.approved)"
      >
        <span class="caption blue--text font-weight-bold"
          ><v-icon small color="blue">timer</v-icon> Currently Awaiting Approval
          -
          {{
            this.workOrderPackage.approvers
              .filter((a) => !a.approved)
              .map((a) => a.name)
              .join(", ")
          }}</span
        >
      </v-col>
    </v-row>
    <v-row wrap v-if="!workOrderPackage.emailSent && editable">
      <v-col cols="12" class="headline pt-0">
        <v-btn color="primary" class="mr-2" @click="saveWorkOrderPackage" small
          ><v-icon left small>save</v-icon>Save Changes</v-btn
        >
        <v-btn color="green" dark class="" @click="approveAndSend" small
          ><v-icon left small>check</v-icon>Approve & Send to Billing</v-btn
        >
      </v-col>
    </v-row>
    <!-- APPROVAL -->
    <v-row
      wrap
      v-for="approver in workOrderPackage.approvers"
      :key="approver.id"
    >
      <v-col
        cols="12"
        sm="12"
        md="6"
        class="summary mb-0 pb-0"
        v-if="!approver.approved && approver.id === user.uid"
      >
        <v-alert prominent type="success" color="primary" outlined>
          <v-row align="center">
            <v-col class="grow"
              >{{ approver.name }}, your approval is required. If you do not
              approve please contact Eric Stears.</v-col
            >
            <v-col class="shrink">
              <v-btn
                class="success"
                @click="
                  approver.approved = true;
                  approve();
                "
                ><v-icon left small>check</v-icon> APPROVE</v-btn
              >
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>
    <!-- SUMMARY -->
    <v-row wrap>
      <v-col cols="12" sm="12" md="6" class="summary">
        <v-card class="mb-4">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" width="50%">Labor</th>
                  <th class="text-right" width="100">Hours</th>
                  <th class="text-right" width="100">Rate</th>
                  <th class="text-right" width="100">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(labor, index) in workOrderPackage.laborCombined"
                  :key="index"
                >
                  <td class="text-left">{{ labor.type }}</td>
                  <td class="text-right">
                    <input
                      v-if="editable"
                      dense
                      type="number"
                      outlined
                      v-model.number="labor.hours"
                      style="width:60px;text-align:right;color:#1e88e5"
                    />
                    <span v-else>{{ labor.hours }}</span>
                  </td>
                  <td class="text-right">
                    <input
                      v-if="editable"
                      dense
                      type="number"
                      outlined
                      v-model.number="labor.rate"
                      style="width:60px;text-align:right;color:#1e88e5"
                    />
                    <span v-else>${{ labor.rate.toFixed(2) }}</span>
                  </td>
                  <td class="text-right">
                    ${{ (labor.hours * labor.rate).toFixed(2) }}
                  </td>
                </tr>
                <tr>
                  <td class="text-left">SUBTOTAL</td>
                  <td class="text-right"></td>
                  <td class="text-right"></td>
                  <td class="text-right">${{ laborCombinedSum.toFixed(2) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
        <!-- MATERIALS -->
        <v-card class="mb-4">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" width="50%">Materials</th>
                  <th class="text-right" width="100">QTY</th>
                  <th class="text-right" width="100">Value</th>
                  <th class="text-right" width="100">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(material, index) in workOrderPackage.materialCombined"
                  :key="index"
                >
                  <td class="text-left">{{ material.title }}</td>
                  <td class="text-right">
                    <input
                      v-if="editable"
                      dense
                      type="number"
                      outlined
                      v-model.number="material.qty"
                      style="width:60px;text-align:right;color:#1e88e5"
                    />
                    <span v-else>{{ material.qty }}</span>
                  </td>
                  <td class="text-right">
                    <input
                      v-if="material.editable && editable"
                      dense
                      type="number"
                      outlined
                      v-model.number="material.unitPrice"
                      style="width:60px;text-align:right;color:#1e88e5"
                    />
                    <span v-else>${{ material.unitPrice.toFixed(2) }}</span>
                  </td>
                  <td class="text-right">
                    ${{ (material.qty * material.unitPrice).toFixed(2) }}
                  </td>
                </tr>
                <tr>
                  <td class="text-left">SUBTOTAL</td>
                  <td class="text-right"></td>
                  <td class="text-right"></td>
                  <td class="text-right">
                    ${{ materialCombinedSum.toFixed(2) }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
        <!-- DEBRIS -->
        <v-card class="mb-4">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" width="50%">Debris</th>
                  <th class="text-right" width="100">Yards</th>
                  <th class="text-right" width="100">Rate</th>
                  <th class="text-right" width="100">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-left">Yardage</td>
                  <td class="text-right">
                    <input
                      v-if="editable"
                      dense
                      type="number"
                      outlined
                      v-model.number="workOrderPackage.debrisYardageCombined"
                      style="width:60px;text-align:right;color:#1e88e5"
                    />
                    <span v-else>{{
                      workOrderPackage.debrisYardageCombined
                    }}</span>
                  </td>
                  <td class="text-right">$60.00</td>
                  <td class="text-right">
                    ${{
                      (workOrderPackage.debrisYardageCombined * 60).toFixed(2)
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
        <!-- DISCOUNTS -->
        <v-card class="mb-4" v-if="workOrderPackage.adjustments.length">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Adjustments / Discounts
                    <a
                      v-if="editable"
                      @click.prevent="addAdjustment"
                      style="border:solid 1px gray;padding: 0 8px;border-radius:2px"
                      class="ml-4"
                      >+ add</a
                    >
                  </th>
                  <th class="text-right" width="100"></th>
                  <th class="text-right" width="100">Amount</th>
                </tr>
              </thead>
              <tbody v-if="workOrderPackage.adjustments.length">
                <tr
                  v-for="(adjustment, ix) in workOrderPackage.adjustments"
                  :key="ix"
                >
                  <td class="text-left pr-0">
                    <input
                      v-if="editable"
                      dense
                      type="text"
                      outlined
                      v-model="adjustment.type"
                      style="width:100%;padding-left:5px;color:#1e88e5"
                    />
                    <span v-else>{{ adjustment.type }}</span>
                  </td>
                  <td class="text-right">
                    <a
                      v-if="editable"
                      @click.prevent="
                        workOrderPackage.adjustments.splice(ix, 1)
                      "
                      style="border:solid 1px gray;padding: 0 8px;border-radius:2px;color:#163758;font-weight:bold;font-size:.75rem"
                      class="ml-4"
                      >remove</a
                    >
                  </td>
                  <td class="text-right">
                    <input
                      v-if="editable"
                      dense
                      type="number"
                      outlined
                      v-model.number="adjustment.amount"
                      style="width:60px;text-align:right;color:#1e88e5"
                    />
                    <span v-else class="red--text text--lighten-1"
                      >-${{ adjustment.amount.toFixed(2) }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
        <!-- TICKET SUMMARY -->
        <v-card>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td class="text-left">Tool Mobilization</td>
                  <td class="text-right">
                    <strong>
                      <input
                        v-if="editable"
                        dense
                        type="number"
                        outlined
                        v-model.number="workOrderPackage.toolMobilization"
                        style="width:60px;text-align:right;color:#1e88e5"
                      />
                      <span v-else
                        >${{
                          workOrderPackage.toolMobilization.toFixed(2)
                        }}</span
                      >
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td class="text-left">Sub Total</td>
                  <td class="text-right">
                    <strong>${{ subTotal.toFixed(2) }}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="text-left">
                    Overhead and Profit (15%)
                  </td>
                  <td class="text-right">
                    <strong>${{ (subTotal * 0.15).toFixed(2) }}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="text-left">
                    TOTAL
                  </td>
                  <td class="text-right">
                    <strong>${{ (subTotal * 1.15).toFixed(2) }}</strong>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
    <!-- WORK ORDERS -->
    <v-row wrap>
      <v-col
        cols="12"
        xs="12"
        v-for="wo in workOrderPackage.workOrders"
        :key="wo.id"
      >
        <work-order-ticket :workOrder="wo" />
      </v-col>
    </v-row>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="submittingApprovalDialog" persistent width="300">
      <v-card color="">
        <v-card-text>
          <p class="pt-4">Approving and Sending to billing...</p>
          <v-progress-linear
            indeterminate
            color="primary"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
import workOrderTicket from "@/components/workOrders/WorkOrderTicket";
import { sumBy } from "lodash";
export default {
  components: {
    workOrderTicket: workOrderTicket,
  },
  data() {
    return {
      workOrderPackage: null,
      pmList: [],
      debrisRate: 60,
      toolMobilization: 0,
      editable: false,
      snack: false,
      snackColor: "",
      snackText: "",
      submittingApprovalDialog: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    adjustmentsTotal() {
      return sumBy(this.workOrderPackage.adjustments, (a) => a.amount);
    },
    laborCombinedSum() {
      return sumBy(
        this.workOrderPackage.laborCombined,
        (lc) => lc.hours * lc.rate
      );
    },
    materialCombinedSum() {
      return sumBy(
        this.workOrderPackage.materialCombined,
        (mc) => mc.qty * mc.unitPrice
      );
    },
    subTotal() {
      return (
        this.laborCombinedSum +
        this.materialCombinedSum +
        this.workOrderPackage.toolMobilization +
        this.workOrderPackage.debrisYardageCombined * 60 -
        this.adjustmentsTotal
      );
    },
  },
  async created() {
    try {
      await this.getWorkOrderPackage();
      if (this.user.role == "Office" && !this.workOrderPackage.emailSent) {
        this.editable = true;
      }
    } catch (error) {
      alert(error);
      // alert("Error getting work orders");
      this.loadingWorkOrders = false;
    }
  },
  methods: {
    async getPmList() {
      const pmList = await fb.db
        .collection("users")
        .where("role", "==", "Project Manager")
        .get();
      this.pmList = [];
      pmList.forEach((u) => {
        this.pmList.push({
          name: u.data().firstName + " " + u.data().lastName,
          email: u.data().email,
          id: u.id,
        });
      });
    },
    async getWorkOrderPackage() {
      this.workOrderPackage = null;
      const workOrderPackage = await fb.db
        .collection("workOrderPackages")
        .doc(`${this.$route.params.id}`)
        .get();
      this.workOrderPackage = workOrderPackage.data();
      console.log(this.workOrderPackage);
    },
    addAdjustment() {
      this.workOrderPackage.adjustments.push({
        type: "-- describe adjustment here --",
        amount: 0,
      });
    },
    async saveWorkOrderPackage() {
      try {
        await fb.db
          .collection("workOrderPackages")
          .doc(`${this.$route.params.id}`)
          .update(this.workOrderPackage);
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Successfully updated Work Order Package!";
        this.getWorkOrderPackage();
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error updating Work Order Package!";
      }
    },
    async approveAndSend() {
      try {
        this.submittingApprovalDialog = true;
        this.workOrderPackage.approvers.forEach((a) => {
          a.approved = true;
        });
        await this.approve();
        this.submittingApprovalDialog = false;
      } catch (error) {
        this.submittingApprovalDialog = false;
        alert("Error submitting to billing. Please contact support.");
      }
    },
    async approve() {
      const payload = {
        approvers: this.workOrderPackage.approvers,
      };
      const allApproved = this.workOrderPackage.approvers.every(
        (a) => a.approved
      );
      if (allApproved) {
        payload.approved = true;
      }
      console.log(payload);
      await fb.db
        .collection("workOrderPackages")
        .doc(`${this.$route.params.id}`)
        .update(payload);
      if (payload.approved) {
        const sendToBilling = await fb.functions.httpsCallable(
          "sendWorkOrdersPackageToBilling"
        );
        await sendToBilling({
          order: this.workOrderPackage.workOrders[0],
          workOrderPackageId: this.$route.params.id,
        });
        console.log("done");
      }
      this.getWorkOrderPackage();
    },
  },
};
</script>
<style scoped>
.summary {
  max-width: 620px;
}
</style>
